'use client'
import Cookies from 'js-cookie'
import {useSearchParams} from 'next/navigation'
import {Suspense, useEffect, useMemo} from 'react'

import amyDayjs from '@/src/shared/lib/dayjs/dayjs'

const AdWriterContent = () => {
  const searchParams = useSearchParams()
  const utmSource = searchParams.get('utm_source')

  const utmTags = useMemo(
    () => [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_content',
      'utm_term',
      'gad_source',
      'gclid',
    ],
    []
  )

  useEffect(() => {
    if (utmSource) {
      const tags = utmTags.map(item => ({[item]: searchParams.get(item)}))
      const utmData = {
        date: amyDayjs().format('DD-MM-YYYY HH:mm:ss'),
        ...Object.assign({}, ...tags),
      }
      Cookies.set('utm', JSON.stringify(utmData), {expires: 30})
    }
  }, [searchParams, utmSource, utmTags])

  return null
}

const AdWriter = () => {
  return (
    <Suspense fallback={null}>
      <AdWriterContent />
    </Suspense>
  )
}

export default AdWriter
